<match-wrapper
    label="{{ label }}"
    subLabel="{{ subLabel }}"
    objectType="{{ objectType }}"
    fieldName="{{ fieldName }}"
    (onRemoveMatch)="removeMatch()"
    [showRemoveIcon]="!disabled"
>
    <div
        class="path-or-query-match__container"
        [ngClass]="{'path-or-query-match__container--no-margin': !showCriteriaAndMatchCaseFields && queryMatchMode}"
        provideParentForm
    >
        <div *ngIf="pathMatchMode || stringMatchMode || showCriteriaAndMatchCaseFields">
            <label
                aviLabelWithTooltip
                objectType="{{ matchObjectType }}"
                fieldName="match_criteria"
                for="match-criteria"
                required
            >
                {{ l10nKeys.criteriaDropdownLabel | vtranslate }}
            </label>
            <avi-dropdown
                name="match-criteria-{{ matchIndex }}"
                id="match-criteria-{{ matchIndex }}"
                [options]="matchCriteriaDropdownOptions"
                [(ngModel)]="editable.config.match_criteria"
                placeholder="{{ l10nKeys.selectMethodPlaceholder | vtranslate }}"
                [disabled]="disabled"
                required
            ></avi-dropdown>
        </div>

        <ng-container *ngIf="!hideQueryMatchConfigurations">
            <avi-checkbox-container-group *ngIf="pathMatchMode || queryMatchMode || showCriteriaAndMatchCaseFields">
                <avi-checkbox
                    *ngIf="pathMatchMode || showCriteriaAndMatchCaseFields"
                    name="match-case-{{ matchIndex }}"
                    [disabled]="disabled"
                    [(ngModel)]="isCaseSensitive"
                    (ngModelChange)="handleCaseSensitiveSelection($event)"
                    objectType="{{ matchObjectType }}"
                    fieldName="match_case"
                >
                    {{ l10nKeys.enableMatchCaseLabel | vtranslate }}
                </avi-checkbox>
                <avi-checkbox
                    *ngIf="pathMatchMode || queryMatchMode"
                    name="match-decoded-string-{{ matchIndex }}"
                    [disabled]="disabled"
                    [(ngModel)]="editable.config.match_decoded_string"
                    objectType="{{ matchObjectType }}"
                    fieldName="match_decoded_string"
                >
                    {{ l10nKeys.matchDecodedStringLabel | vtranslate }}
                </avi-checkbox>
            </avi-checkbox-container-group>

            <string-group-or-custom-value
                *ngIf="!disallowStringGroups"
                class="path-or-query-match__string-group-or-custom-value path-or-query-match__string-container"
                [(stringGroupRefs)]="editable.config.string_group_refs"
                [(customValues)]="editable.config.match_str"
                [id]="'path-or-query-match_' + fieldName + matchIndex"
                [disabled]="disabled"
                [noMarginTop]="true"
                [areDuplicateCustomValuesAllowed]="areDuplicateCustomValuesAllowed"
            ></string-group-or-custom-value>

        </ng-container>
    </div>
</match-wrapper>
